import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Message } from '@app/core/models/message.model';

@Pipe({
  name: 'avatarText'
})
export class AvatarTextPipe implements PipeTransform {

  constructor(private _domSanitizer: DomSanitizer) { }

  transform(message: Message): SafeHtml {
    if (!message.senderUserName) {
      return this._domSanitizer.bypassSecurityTrustHtml("<span style='font-family:Material Icons'>message</span>");
    }
    const names = message.senderUserName.split(' ');
		return (
			names[0].charAt(0) + (names.length > 1 ? names[names.length - 1].charAt(0) : '')
		);
  }

}
